"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPatientGroupPayload = exports.getFilteredInfoData = exports.getLupaData = exports.validatePatientGroupForm = exports.validateFormDataLength = exports.checkDobValidation = exports.validateAddInfo = exports.isValidInfoDetail = exports.isValidPhoneNo = exports.normalizePhoneNo = exports.getRequestData = exports.prepareRequestFromGroupInfo = exports.mapGroupInfoToILupaData = exports.mapGroupInfoToIReferralInfo = exports.mapUpdatedGroupInfoToPatientInfo = exports.normalizeDob = exports.dateToDobString = exports.dobStringToDate = exports.defaultErrors = exports.defaultInfo = exports.defaultPatientInfoData = void 0;
const domain_1 = require("@home-health-notify/domain");
const dayjs_1 = __importDefault(require("dayjs"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const ValidationHelper_1 = require("./ValidationHelper");
// ─── Defaults ────────────────────────────────────────────────────────────────
exports.defaultPatientInfoData = {
    countryCode: domain_1.CountryCode.US,
    dob: "",
    firstName: "",
    lastName: "",
    mrn: "",
    phoneNo: "",
    address: {
        apartmentNo: "",
        lat: 0,
        lng: 0,
        placeName: "",
    },
    info: { careGiver: [], pharmacy: [], physician: [] },
    about: "",
    insurance: "",
    meta: "",
};
exports.defaultInfo = {
    physician: [],
    careGiver: [],
    pharmacy: [],
};
exports.defaultErrors = {
    firstName: false,
    lastName: false,
    mrn: false,
    dob: false,
    phoneNumber: false,
    address: false,
};
// ─── DOB helpers ─────────────────────────────────────────────────────────────
// The date of birth is a calendar date with no time/timezone, kept as an
// "MM/DD/YYYY" string everywhere it is stored or sent. Convert to/from a Date
// only at the DatePicker boundary, using local date parts so the day never
// shifts across timezones (and avoiding Hermes' ISO-only string parsing).
const dobStringToDate = (dob) => {
    const match = typeof dob === "string"
        ? dob.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
        : null;
    if (!match)
        return undefined;
    const [, month, day, year] = match;
    return new Date(Number(year), Number(month) - 1, Number(day));
};
exports.dobStringToDate = dobStringToDate;
const dateToDobString = (date) => {
    if (!date)
        return "";
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${month}/${day}/${date.getFullYear()}`;
};
exports.dateToDobString = dateToDobString;
// External sources (the clipboard EMR parser, edit/wire payloads) hand us the
// dob as a string, a Date, or a Dayjs. Normalize any of them to the canonical
// "MM/DD/YYYY" string using local date parts so the day never shifts.
const normalizeDob = (dob) => {
    if (!dob)
        return "";
    if (typeof dob === "string")
        return dob;
    if (dayjs_1.default.isDayjs(dob))
        return dob.isValid() ? dob.format("MM/DD/YYYY") : "";
    if (dob instanceof Date)
        return isNaN(dob.getTime()) ? "" : (0, exports.dateToDobString)(dob);
    return "";
};
exports.normalizeDob = normalizeDob;
// ─── Mapping Functions ───────────────────────────────────────────────────────
const mapUpdatedGroupInfoToPatientInfo = (groupInfo) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    return {
        countryCode: ((_a = groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.patientInfo) === null || _a === void 0 ? void 0 : _a.countryCode) || domain_1.CountryCode.US,
        dob: (0, exports.normalizeDob)((_b = groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.patientInfo) === null || _b === void 0 ? void 0 : _b.dob),
        firstName: ((_c = groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.patientInfo) === null || _c === void 0 ? void 0 : _c.firstName) || "",
        lastName: ((_d = groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.patientInfo) === null || _d === void 0 ? void 0 : _d.lastName) || "",
        mrn: (groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.mrn) || "",
        phoneNo: ((_e = groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.patientInfo) === null || _e === void 0 ? void 0 : _e.phoneNo) || "",
        address: {
            apartmentNo: (_h = (_g = (_f = groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.patientInfo) === null || _f === void 0 ? void 0 : _f.address) === null || _g === void 0 ? void 0 : _g.apartmentNo) !== null && _h !== void 0 ? _h : "",
            lat: (_l = (_k = (_j = groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.patientInfo) === null || _j === void 0 ? void 0 : _j.address) === null || _k === void 0 ? void 0 : _k.lat) !== null && _l !== void 0 ? _l : 0,
            lng: (_p = (_o = (_m = groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.patientInfo) === null || _m === void 0 ? void 0 : _m.address) === null || _o === void 0 ? void 0 : _o.lng) !== null && _p !== void 0 ? _p : 0,
            placeName: (_s = (_r = (_q = groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.patientInfo) === null || _q === void 0 ? void 0 : _q.address) === null || _r === void 0 ? void 0 : _r.placeName) !== null && _s !== void 0 ? _s : "",
        },
        info: (groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.info) || exports.defaultInfo,
        about: (groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.about) || "",
        insurance: (groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.insurance) || "",
        meta: (groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.meta) || "",
    };
};
exports.mapUpdatedGroupInfoToPatientInfo = mapUpdatedGroupInfoToPatientInfo;
const mapGroupInfoToIReferralInfo = (groupInfo) => {
    return {
        referralSource: groupInfo ? groupInfo.referralSource : "",
        communityLiaison: groupInfo ? groupInfo.communityLiaisoning : "",
        attachments: groupInfo ? groupInfo.attachments : [],
    };
};
exports.mapGroupInfoToIReferralInfo = mapGroupInfoToIReferralInfo;
const mapGroupInfoToILupaData = (groupInfo) => {
    var _a, _b, _c, _d;
    return {
        firstSession: groupInfo ? Number((_b = (_a = groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.lupa) === null || _a === void 0 ? void 0 : _a.firstSession) !== null && _b !== void 0 ? _b : 0) : 0,
        secondSession: groupInfo ? Number((_d = (_c = groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.lupa) === null || _c === void 0 ? void 0 : _c.secondSession) !== null && _d !== void 0 ? _d : 0) : 0,
    };
};
exports.mapGroupInfoToILupaData = mapGroupInfoToILupaData;
// ─── Request Data ────────────────────────────────────────────────────────────
const prepareRequestFromGroupInfo = (attachments, fileCaptionMap) => {
    const attachmentFiles = [];
    (attachments || []).forEach(function (file) {
        var _a, _b, _c;
        const caption = (_a = fileCaptionMap.get(file.id)) !== null && _a !== void 0 ? _a : "";
        attachmentFiles.push(Object.assign({ url: file.media[0].url, size: (_b = file.size) !== null && _b !== void 0 ? _b : "", type: file.type === domain_1.ATTACHMENT_TYPE.JPG
                ? domain_1.ASSET_TYPE.MEDIA
                : domain_1.ASSET_TYPE.DOCUMENT, attachmentType: ((_c = file.type) !== null && _c !== void 0 ? _c : "") }, (caption && { text: caption })));
    });
    return attachmentFiles;
};
exports.prepareRequestFromGroupInfo = prepareRequestFromGroupInfo;
const getRequestData = (patientGroupInfo, attachmentsFiles, selectedMembers) => {
    var _a;
    const { about, insurance, info, meta, patientInfo } = patientGroupInfo, restPatientInfo = __rest(patientGroupInfo, ["about", "insurance", "info", "meta", "patientInfo"]);
    const trimmedFirstName = normalizeNamePart(patientInfo === null || patientInfo === void 0 ? void 0 : patientInfo.firstName);
    const trimmedLastName = normalizeNamePart(patientInfo === null || patientInfo === void 0 ? void 0 : patientInfo.lastName);
    const patientName = joinPatientName(trimmedFirstName, trimmedLastName);
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, selectedMembers), restPatientInfo), (about && { about })), (insurance && { insurance })), (meta && { meta })), { info, patientInfo: Object.assign(Object.assign({}, patientInfo), { firstName: trimmedFirstName, lastName: trimmedLastName, name: patientName, dob: (_a = patientInfo.dob) !== null && _a !== void 0 ? _a : "" }), name: patientName, attachments: attachmentsFiles.map((_a) => {
            var { size } = _a, rest = __rest(_a, ["size"]);
            return size === "" ? Object.assign({}, rest) : Object.assign(Object.assign({}, rest), { size });
        }) });
};
exports.getRequestData = getRequestData;
// ─── Validation ──────────────────────────────────────────────────────────────
const normalizePhoneNo = (phoneNo) => {
    return phoneNo.replace(/\D/g, "");
};
exports.normalizePhoneNo = normalizePhoneNo;
// Patient identity is firstName + lastName + dob. Edge whitespace must be
// stripped off each part before it is joined, or "Jane " + "Doe" yields a
// doubled interior space that no amount of trimming the joined name removes,
// and the duplicate check sees a different patient.
const normalizeNamePart = (namePart) => typeof namePart === "string" ? namePart.trim() : "";
const joinPatientName = (firstName, lastName) => [firstName, lastName].filter(Boolean).join(" ");
const isValidPhoneNo = (phoneNo) => {
    return (0, exports.normalizePhoneNo)(phoneNo).length === 10;
};
exports.isValidPhoneNo = isValidPhoneNo;
const isValidInfoDetail = (data) => {
    return (!(0, isEmpty_1.default)(data.name) &&
        data.name.trim().length > 0 &&
        !(0, isEmpty_1.default)(data.phoneNo) &&
        (0, exports.isValidPhoneNo)(data.phoneNo));
};
exports.isValidInfoDetail = isValidInfoDetail;
const validateAddInfo = (info) => {
    var _a, _b;
    const categories = ["physician", "careGiver", "pharmacy"];
    for (const category of categories) {
        const entries = (_a = info === null || info === void 0 ? void 0 : info[category]) !== null && _a !== void 0 ? _a : [];
        for (let i = 0; i < Math.min(entries.length, 2); i++) {
            const entry = entries[i];
            if (entry !== undefined) {
                const hasName = (_b = entry.name) === null || _b === void 0 ? void 0 : _b.trim();
                const hasPhone = entry.phoneNo;
                if ((hasName && !hasPhone) || (hasPhone && !hasName)) {
                    return false;
                }
                if (hasPhone && !(0, exports.isValidPhoneNo)(hasPhone)) {
                    return false;
                }
            }
        }
    }
    return true;
};
exports.validateAddInfo = validateAddInfo;
const checkDobValidation = (dateValue) => {
    const date_regex = /^\d{2}\/\d{2}\/\d{4}$/;
    const validDate = date_regex.test(dateValue);
    if (validDate) {
        const [month, day, year] = dateValue.split("/");
        if (+year < 1000) {
            return false;
        }
        const dateObj = new Date(+year, +month - 1, +day);
        if (!(0, ValidationHelper_1.isValidDateOfBirth)(dateObj)) {
            return false;
        }
        return true;
    }
    return false;
};
exports.checkDobValidation = checkDobValidation;
const validateFormDataLength = (data) => {
    return (!data.firstName ||
        !data.lastName ||
        !data.dob ||
        !(0, exports.isValidPhoneNo)(data.phoneNo) ||
        !data.address.placeName);
};
exports.validateFormDataLength = validateFormDataLength;
const validatePatientGroupForm = (data, errors) => {
    const isError = Object.values(errors).find(error => error);
    return ((0, exports.validateFormDataLength)(data) || !(0, exports.validateAddInfo)(data.info) || !!isError);
};
exports.validatePatientGroupForm = validatePatientGroupForm;
// ─── Payload Builders ────────────────────────────────────────────────────────
const getLupaData = (lupaData) => {
    return Object.assign(Object.assign({}, lupaData), { firstSession: lupaData.firstSession || 0, secondSession: lupaData.secondSession || 0 });
};
exports.getLupaData = getLupaData;
// isValidInfoDetail accepts an entry once its phone normalizes to 10 digits, so
// the payload has to send those same digits - the backend caps phoneNo at 10
// characters, and none of the three sources (manual entry, the EMR paste parser,
// the EMR REST lookup) strip formatting completely on the way in.
const toPayloadInfoDetails = (entries = []) => entries
    .filter(data => (0, exports.isValidInfoDetail)(data))
    .map(data => (Object.assign(Object.assign({}, data), { phoneNo: (0, exports.normalizePhoneNo)(data.phoneNo) })));
const getFilteredInfoData = (info) => {
    return {
        careGiver: toPayloadInfoDetails(info === null || info === void 0 ? void 0 : info.careGiver),
        pharmacy: toPayloadInfoDetails(info === null || info === void 0 ? void 0 : info.pharmacy),
        physician: toPayloadInfoDetails(info === null || info === void 0 ? void 0 : info.physician),
    };
};
exports.getFilteredInfoData = getFilteredInfoData;
const buildPatientGroupPayload = (updatedPatientGroupData, patientStatus, socStarter, lupaData, referralInfo) => {
    const { phoneNo, firstName, lastName, countryCode, dob, address, mrn } = updatedPatientGroupData;
    const trimmedFirstName = normalizeNamePart(firstName);
    const trimmedLastName = normalizeNamePart(lastName);
    const patientFields = {};
    patientFields["patientInfo"] = {
        name: joinPatientName(trimmedFirstName, trimmedLastName),
        phoneNo: (0, exports.normalizePhoneNo)(phoneNo),
        firstName: trimmedFirstName,
        lastName: trimmedLastName,
        countryCode,
        dob: dob !== null && dob !== void 0 ? dob : "",
        address,
    };
    const trimmedMrn = mrn === null || mrn === void 0 ? void 0 : mrn.trim();
    trimmedMrn && (patientFields["mrn"] = trimmedMrn);
    patientStatus && (patientFields["patientStatus"] = patientStatus);
    patientFields["insurance"] = updatedPatientGroupData.insurance;
    patientFields["meta"] = updatedPatientGroupData.meta;
    patientFields["socStarter"] = {
        SN: socStarter === domain_1.CLINICIAN_ROLES.SN,
        PT: socStarter === domain_1.CLINICIAN_ROLES.PT,
        SLP: socStarter === domain_1.CLINICIAN_ROLES.SLP,
        OT: socStarter === domain_1.CLINICIAN_ROLES.OT,
    };
    patientFields["lupa"] = (0, exports.getLupaData)(lupaData);
    referralInfo.referralSource &&
        (patientFields["referralSource"] = referralInfo.referralSource);
    referralInfo.communityLiaison &&
        (patientFields["communityLiaisoning"] = referralInfo.communityLiaison);
    patientFields["info"] = (0, exports.getFilteredInfoData)(updatedPatientGroupData.info);
    patientFields["about"] = updatedPatientGroupData.about;
    return patientFields;
};
exports.buildPatientGroupPayload = buildPatientGroupPayload;
